import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const CenterFocusIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 12C17 9.24 14.76 7 12 7S7 9.24 7 12S9.24 17 12 17S17 14.76 17 12ZM12 15C10.35 15 9 13.65 9 12S10.35 9 12 9S15 10.35 15 12S13.65 15 12 15ZM5 15L3 15L3 19C3 20.1 3.9 21 5 21L9 21L9 19L5 19L5 15ZM5 5L9 5L9 3L5 3C3.9 3 3 3.9 3 5L3 9L5 9L5 5ZM19 3L15 3L15 5L19 5L19 9L21 9L21 5C21 3.9 20.1 3 19 3ZM19 19L15 19L15 21L19 21C20.1 21 21 20.1 21 19L21 15L19 15L19 19Z"
      fill="currentColor"
    />
  </svg>
);

CenterFocusIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(CenterFocusIcon);
